import {
  Button,
  HStack,
  Avatar,
  List,
  ListItem,
  Text,
  Box,
  VStack,
  CircularProgress,
} from "@chakra-ui/react";
import { ChevronRightIcon } from "@chakra-ui/icons";

import { useHistory } from "react-router-dom";

import { CgDatabase } from "react-icons/cg";

import uniqBy from "lodash/uniqBy";

const ReferrerListItem = ({ name, onClick }) => {
  return (
    <ListItem
      as={Button}
      bg="white"
      w="100% !important"
      minH="fit-content"
      h="fit-content"
      minW="fit-content"
      py="10px"
      px="18px"
      variant="ghost"
      _focus={{ shadow: "0 0 0 3px var(--focusColor)" }}
      //   _hover={{ shadow: "0 0 0 3px var(--focusColor)" }}
      shadow="0px 0px 5px rgba(0, 0, 0, 0.05)"
      my="4px"
      borderRadius="10px"
      onClick={onClick}
    >
      <HStack w="100%" justifyContent="space-between">
        <HStack>
          <Avatar name={name} />
          <Text ml="10px !important">{name}</Text>
        </HStack>

        <Box fontSize="22px" as={ChevronRightIcon} />
      </HStack>
    </ListItem>
  );
};

const ReferrerList = ({ listType, isLoading, data }) => {
  const history = useHistory();

  const list = uniqBy(data, (it) => it?.userId ?? it?._id);

  // console.log("DATA", data, list);
  return (
    <>
      {data?.length < 1 && !isLoading && (
        <VStack py="32px">
          <Box as={CgDatabase} fontSize="48px" color="grey" />
          <Text color="grey">No Data</Text>
        </VStack>
      )}

      {isLoading && (
        <VStack py="32px">
          <CircularProgress
            ml="20px !important"
            isIndeterminate
            color="var(--primary)"
            size="20px"
          />
        </VStack>
      )}

      {data && (
        <List>
          {(list ?? []).map((item, i) => (
            <ReferrerListItem
              key={item?._id}
              name={item?.fullName ?? `${item?.firstName} ${item?.lastName}`}
              onClick={() =>
                history.push(
                  `/dashboard/account/refer/${listType ?? "trades"}/${
                    item?.userId ?? item?._id
                  }`,
                  item
                )
              }
            />
          ))}
        </List>
      )}
    </>
  );
};

export default ReferrerList;
